import { useEffect, useState } from "react";
import OrcamentoVendaService from "../../services/service.orcamentovenda";
import T from "../../common/traducao";
import { Alert, LinearProgress, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { GetConfiguracoes } from "../../config/localstorageConfig/localstorage";

const DuplicarOrcamento = (props) => {

    const [retornoOrcamentoDuplicado, setRetornoOrcamentoDuplicado] = useState('');
    const [retornoErroDuplicacaoOrcamento, setRetornoErroDuplicacaoOrcamento] = useState('');
    const [loading, setLoading] = useState(false);

    const constantes = T();
    const { id } = props;


    const Configuracoes = GetConfiguracoes();

    const navigate = useNavigate();

    async function DuplicarOrcamento() {
        
        setLoading(true);
        if (Configuracoes?.ConfiguracaoWeb?.ConfigWebJson?.situacaoPadraoNovoOrcamentoVendaDuplicado === 'Rascunho') {
            navigate(`/orcamentosvenda/duplicar/${id}`)
            return;
        }

        await OrcamentoVendaService.DuplicarOrcamento(id)
            .then((response) => {
                setRetornoOrcamentoDuplicado(`${constantes.MsgOrcamentoDuplicado} ${response.data.Id}`);
                toast.success(`${constantes.MsgOrcamentoDuplicado} ${response.data.Id}`);
            })
            .catch((error) => {
                const _error =
                    error.code === "ERR_NETWORK"
                        ? "Server OffLine"
                        : error.response && error.response.data && error.response.data.error
                            ? error.response.data.error.message
                            : error.message;
                setRetornoErroDuplicacaoOrcamento(_error);
    
            })
            .finally(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        DuplicarOrcamento();
    }, [])


    return (
         <>
            <Typography sx={{fontSize: 18}}>{constantes.MsgDuplicarOrcamento} {id}</Typography>

            {retornoErroDuplicacaoOrcamento &&

                <Alert variant="danger">
                    {retornoErroDuplicacaoOrcamento}
                </Alert>}

            {retornoOrcamentoDuplicado &&
                <Alert variant="success">
                    {retornoOrcamentoDuplicado}
                </Alert>}

            {' '}
            {loading && <LinearProgress color="inherit"  />}

        </>
    )
}

export default DuplicarOrcamento;